import styled from 'styled-components';

export const Container = styled.div`
  background: #242526;
  border-radius: 20px;
  padding: 20px;
`;
